<ng-container *transloco="let t; prefix: 'dashboard_transactions'">
  <!-- Transaction Details modal -->
  <qwiko-modal
    [id]="'transactions-breakdown'"
    [isCentered]="true"
    [isFullScreen]="true"
    [isDismissible]="true"
  >
    <div
      class="top-0 right-0 left-0 z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
    >
      <div class="flex md:hidden justify-start items-center mb-2 w-full">
        <button
          type="button"
          class="btn btn-sm btn-ghost rounded-full"
          (click)="closeModal('transactions-breakdown')"
        >
          <span class="flex items-center gap-1">
            <i class="fa-light text-xl fa-arrow-left"></i>
            <span class="text-base mt-1" *transloco="let t">
              {{ t("back") }}
            </span>
          </span>
        </button>
      </div>
      <div class="hidden md:flex justify-end items-center mb-2 w-full">
        <button
          type="button"
          class="btn btn-sm btn-ghost rounded-full"
          (click)="closeModal('transactions-breakdown')"
        >
          <span class="flex items-center gap-1">
            <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
              t("close")
            }}</span>
            <i class="fa-light text-base fa-xmark"></i>
          </span>
        </button>
      </div>
      <div class="w-full px-4 py-2 mx-auto">
        <!-- <img
          class="rounded-full size-16 md:w-20 md:h-20 mx-auto mb-4"
          src="/assets/icons/flags/RW.svg"
          alt=""
        /> -->
        <h2 class="text-2xl font-normal text-center w-full">
          {{ t("transactions_breakdown") }}
        </h2>
        <!-- <h2 class="text-xl font-normal text-center w-full mb-2">
          {{ selectedProvider()?.display_name }}
          Name here
        </h2> -->
      </div>
    </div>

    <div class="w-full px-4 mx-auto my-5">
      <div class="mt-5 mb-2">
        <h3 class="text-xs md:text-base uppercase">
          {{ t("today_statistics") }}
        </h3>
      </div>
      <div class="grid grid-cols-1 gap-2 mb-4">
        <div class="stats shadow bg-neutral-100 dark:bg-base-100 rounded-box">
          <div class="stat p-2 md:p-4">
            <div
              class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
            >
              <i class="fa-solid fa-exchange text-2xl"></i>
            </div>
            <div class="stat-title text-base dark:text-slate-300 mb-1">
              {{ t("total") }}
            </div>
            <div
              class="stat-value text-4xl leading-none dark:text-slate-300 text-primary"
            >
              {{ this.transactions().length }}
            </div>
            <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +288 this Month
                  </div> -->
          </div>
        </div>

        <div class="stats shadow bg-neutral-100 dark:bg-base-100 rounded-box">
          <div class="stat p-2 md:p-4">
            <div
              class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
            >
              <i class="fa-solid fa-circle-check text-slate-500 text-4xl"></i>
            </div>
            <div class="stat-title text-base dark:text-slate-300 mb-1">
              {{ t("initiated") }}
            </div>
            <div class="stat-value text-4xl text-slate-500 leading-none">
              {{ this.initiatedTransactions() }}
            </div>
            <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +528 this Month
                  </div> -->
          </div>
        </div>

        <div class="stats shadow bg-neutral-100 dark:bg-base-100 rounded-box">
          <div class="stat p-2 md:p-4">
            <div
              class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
            >
              <i class="fa-solid fa-hourglass-clock text-warning text-3xl"></i>
            </div>
            <div class="stat-title text-base dark:text-slate-300 mb-1">
              {{ t("pending") }}
            </div>
            <div class="stat-value text-4xl text-warning leading-none">
              {{ this.pendingTransactions() }}
            </div>
            <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +1.3M this Month
                  </div> -->
          </div>
        </div>

        <div class="stats shadow bg-neutral-100 dark:bg-base-100 rounded-box">
          <div class="stat p-2 md:p-4">
            <div
              class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
            >
              <i class="fa-solid fa-circle-check text-success text-4xl"></i>
            </div>
            <div class="stat-title text-base dark:text-slate-300 mb-1">
              {{ t("confirmed") }}
            </div>
            <div class="stat-value text-4xl text-success leading-none">
              {{ this.confirmedTransactions() }}
            </div>
            <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +1.3M this Month
                  </div> -->
          </div>
        </div>
        <div class="stats shadow bg-neutral-100 dark:bg-base-100 rounded-box">
          <div class="stat p-2 md:p-4">
            <div
              class="stat-figure dark:text-slate-300 text-primary hidden md:flex"
            >
              <i
                class="fa-solid fa-circle-xmark text-slate-400 dark:text-slate-600 text-4xl"
              ></i>
            </div>
            <div class="stat-title text-base dark:text-slate-300 mb-1">
              {{ t("canceled") }}
            </div>
            <div
              class="stat-value text-4xl text-slate-400 dark:text-slate-600 leading-none"
            >
              {{ this.canceledTransactions() }}
            </div>
            <!-- <div class="stat-desc font-bold text-green-700 dark:text-green-300">
                    +1.3M this Month
                  </div> -->
          </div>
        </div>
      </div>
    </div>
  </qwiko-modal>
</ng-container>
